import { Injectable } from '@angular/core';
import { PrimeNG } from 'primeng/config';
@Injectable({
  providedIn: 'root',
})
export class PrimeNGConfigService {
  constructor(private _primeng: PrimeNG) {
    const dayNames = [
      $localize`Niedziela`,
      $localize`Poniedziałek`,
      $localize`Wtorek`,
      $localize`Środa`,
      $localize`Czwartek`,
      $localize`Piątek`,
      $localize`Sobota`,
    ];
    const monthNames = [
      $localize`Styczeń`,
      $localize`Luty`,
      $localize`Marzec`,
      $localize`Kwiecień`,
      $localize`Maj`,
      $localize`Czerwiec`,
      $localize`Lipiec`,
      $localize`Sierpień`,
      $localize`Wrzesień`,
      $localize`Październik`,
      $localize`Listopad`,
      $localize`Grudzień`,
    ];
    this._primeng.ripple.set(true);
    this._primeng.setTranslation({
      emptyMessage: $localize`Brak danych`,
      firstDayOfWeek: 1,
      dayNames: dayNames,
      dayNamesShort: dayNames.map((dn) => dn.substring(0, 3)),
      dayNamesMin: dayNames.map((dn) => dn.substring(0, 1)),
      monthNames: monthNames,
      monthNamesShort: monthNames.map((mn) => mn.substring(0, 3)),
      today: $localize`Dzisiaj`,
      clear: $localize`Wyczyść`,
      apply: $localize`Zastosuj`,
      addRule: $localize`Dodaj warunek`,
      removeRule: $localize`Usuń warunek`,
      matchAll: $localize`Dopasuj wszystko`,
      matchAny: $localize`Dopasuj dowolny`,
      dateIs: $localize`Data równa się`,
      dateIsNot: $localize`Data nie równa się`,
      dateAfter: $localize`Data po`,
      dateBefore: $localize`Data przed`,
      equals: $localize`Równa się`,
      notEquals: $localize`Nie równa się`,
      lt: $localize`Mniej niż`,
      lte: $localize`Mniej lub równe`,
      gt: $localize`Więcej niż`,
      gte: $localize`Więcej lub równe`,
      startsWith: $localize`Rozpoczyna się od`,
      endsWith: $localize`Kończy się na`,
      contains: $localize`Zawiera`,
      notContains: $localize`Nie zawiera`,
    });

    this._primeng.overlayOptions = {
      hideOnEscape: true,
    };
  }
}
